export var getWindow = function getWindow() {
  if (typeof window === 'undefined') return {};
  return window;
};